import { DatePipe } from '@angular/common';
import { ViewChild } from '@angular/core';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MdbTableDirective, MdbTablePaginationComponent } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { ComprasService } from '../compras.service';
import { VCompras } from '../vcompras';

@Component({
  selector: 'app-lista-compras',
  templateUrl: './lista-compras.component.html',
  styleUrls: ['./lista-compras.component.scss']
})
export class ListaComprasComponent implements OnInit {
  popoverTitle = 'Popover title';
  popoverMessage = 'Popover description';
  confirmClicked = false;
  cancelClicked = false;
  fecha: string;
  lista: VCompras[]=[];
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective

  constructor( private datePipe: DatePipe,private alertService: AlertService,private api: ComprasService, private cdRef: ChangeDetectorRef, private formBuilder: FormBuilder, private ruter: Router) { }

  ngOnInit(): void {
  }


  agregar()
  {
    this.ruter.navigate(['detallecompras']);
    
  }

  anularegreso()
  {
    if(confirm("Está seguro de anular la compra")) {
      if(confirm("Se genera un nuevo egreso por devoluciòn.....")) {
      console.log("Implement delete functionality here");
    }
  }

  }

  ver(entidad: VCompras){
    this.ruter.navigate(['vercompras' ,{ id: entidad.id }]);
  }



  buscar() {

    this.api.listaCompras(this.datePipe.transform(this.fecha, "dd-MM-yyyy"),localStorage.getItem('id'))
      .subscribe((
        data: VCompras[]) => {

        this.lista = data;
        console.log(this.lista);
        this.mdbTable.setDataSource(this.lista);
        this.mdbTable.dataSourceChange();

      },
        err => this.alertService.danger('Error no hay  conexion..')
      );
  }


}
